import {BaseViewModel} from "../../../../../infrastructure/models/base-view-model";
import {OrderByPositionDomainModel} from "./order-by-position.domain-model";

export class OrderByPositionViewModel extends BaseViewModel {
  domainModel: OrderByPositionDomainModel;

  get position(): String {
    return this.domainModel.position;
  }

  get positionOrder(): Number {
    return this.domainModel.positionOrder;
  }
}